import { of } from "rxjs";
import { map } from "rxjs/operators";
import { HttpStatusCode, ServerResponseStatus } from "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
class CountriesApiService {
  _httpService;
  _apiUrl;
  constructor(httpService, apiUrl) {
    this._httpService = httpService;
    this._apiUrl = apiUrl;
  }
  getCountries() {
    const endpoint = this.getCountriesEndpoint();
    return this._httpService.get({ endpoint });
  }
  getStates(countryIsoCode) {
    if (countryIsoCode && countryIsoCode !== "undefined") {
      const endpoint = this.getStatesEndpoint(countryIsoCode);
      return this._httpService.get({ endpoint }).pipe(
        map((response) => {
          const responseStatus = response?.errors?.length === 1 && response.errors[0].code === HttpStatusCode.NotFound.toString() ? ServerResponseStatus.Success : response.status;
          return {
            ...response,
            status: responseStatus,
            responsePayload: response?.responsePayload?.subdivisions
          };
        })
      );
    }
    return of();
  }
  getCountriesEndpoint() {
    return `${this._apiUrl}/api/countries`;
  }
  getStatesEndpoint(countryIsoCode) {
    return `${this._apiUrl}/api/countries/${countryIsoCode}/subdivisions`;
  }
}
export {
  CountriesApiService
};
//# sourceMappingURL=apiService.js.map
